import { render, staticRenderFns } from "./TransporterBidRateDialog.vue?vue&type=template&id=f379269e"
import script from "./TransporterBidRateDialog.vue?vue&type=script&lang=js"
export * from "./TransporterBidRateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports